var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"chinese-input",on:{"click":()=>{
        this.numbershow=true;
    }}},[(!_vm.numberInput)?_c('span',{staticClass:"placeholder"},[_vm._v(_vm._s(_vm.placeholder))]):_c('span',[_vm._v(_vm._s(_vm.numberInput))])]),(_vm.numbershow)?_c('div',{staticClass:"number-dit",on:{"click":()=>this.numbershow=false}},[_c('van-number-keyboard',{attrs:{"show":true,"extra-key":"清空"},on:{"input":(value)=>_vm.xuanz(value),"delete":()=>_vm.deletez()}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }